(function () {
	var persianDigits = "۰۱۲۳۴۵۶۷۸۹";
	var asciiDigits = "0123456789";
	var gregorianDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var jalaliDaysInMonth = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

	function getBootLocalization() {
		if (window.frappe && window.frappe.boot && window.frappe.boot.rqerp_localization) {
			return window.frappe.boot.rqerp_localization;
		}
		var loginSurface = document.querySelector(".st-login-wrapper[data-product-name]");
		if (loginSurface) {
			return {
				language: "fa",
				direction: "rtl",
				product_name: loginSurface.dataset.productName || "RQ ERP",
				service_name: loginSurface.dataset.productName || "RQ ERP",
				persian_product_name: loginSurface.dataset.persianProductName || loginSurface.dataset.productName || "RQ ERP",
				persian_service_name: loginSurface.dataset.persianProductName || loginSurface.dataset.productName || "RQ ERP",
				identity_provider_name: loginSurface.dataset.identityProviderName || "RQidentity",
			};
		}
		return {
			language: document.documentElement.lang || "fa",
			direction: "rtl",
			product_name: "RQ ERP",
			service_name: "RQ ERP",
			persian_product_name: "RQ ERP",
			persian_service_name: "RQ ERP",
			identity_provider_name: "RQidentity",
		};
	}

	var textMap = {
		"Sign In": "ورود",
		"Welcome! Please sign in to continue.": "برای ادامه، با حساب سازمانی وارد شوید.",
		"Email": "ایمیل",
		"Email Address": "نشانی ایمیل",
		"Email or mobile number": "ایمیل یا شماره موبایل",
		"Password": "گذرواژه",
		"Continue": "ادامه",
		"Login": "ورود",
		"Login to RQ ERP": "ورود به RQ ERP",
		"Login to NXerp": "ورود به ان‌ایکس‌ای‌آرپی",
		"Login to AgriERP": "ورود به اگری‌ای‌آرپی",
		"Create a RQ ERP Account": "ایجاد حساب RQ ERP",
		"Create a NXerp Account": "ایجاد حساب ان‌ایکس‌ای‌آرپی",
		"Create a AgriERP Account": "ایجاد حساب اگری‌ای‌آرپی",
		"Create Account": "ایجاد حساب",
		"Login with Email Link": "ورود با لینک ایمیلی",
		"Send Link": "ارسال لینک",
		"Send login link": "ارسال لینک ورود",
		"Login with NXidentity Zitadel": "ورود با RQidentity",
		"ورود با NXidentity Zitadel": "ورود با RQidentity",
		"Login with RQidentity Zitadel": "ورود با RQidentity",
		"Forgot Password?": "فراموشی گذرواژه؟",
		"Forgot password?": "فراموشی گذرواژه؟",
		"Forgot Password": "فراموشی گذرواژه",
		"Reset Password": "بازنشانی گذرواژه",
		"Back to Login": "بازگشت به ورود",
		"Don't have an account?": "حساب کاربری ندارید؟",
		"Sign up": "ثبت‌نام",
		"Show": "نمایش",
		"Hide": "پنهان",
		"Email is required": "ایمیل الزامی است",
		"Email is required.": "ایمیل الزامی است.",
		"Password is required": "گذرواژه الزامی است",
		"Password is required.": "گذرواژه الزامی است.",
		"Invalid Email": "ایمیل معتبر نیست",
		"Invalid Email.": "ایمیل معتبر نیست.",
		"Please enter a valid email address": "لطفاً یک ایمیل معتبر وارد کنید",
		"Please enter a valid email address.": "لطفاً یک ایمیل معتبر وارد کنید.",
		"Full name is required": "نام کامل الزامی است",
		"Full name is required.": "نام کامل الزامی است.",
		"Invalid credentials, try again.": "اطلاعات ورود درست نیست. دوباره تلاش کنید.",
		"Oops! Something went wrong.": "خطایی رخ داد. لطفا دوباره تلاش کنید.",
		"Too many requests. Please try again later.": "تعداد تلاش‌ها زیاد است. کمی بعد دوباره تلاش کنید.",
		"Something went wrong.": "خطایی رخ داد.",
		"Javascript is disabled on your browser": "جاوااسکریپت مرورگر غیرفعال است",
		"You need to enable JavaScript for your app to work.": "برای استفاده از سامانه باید جاوااسکریپت فعال باشد.",
		"Verification": "راستی‌آزمایی",
		"Verification Code": "کد راستی‌آزمایی",
		"Verify": "تأیید",
		"Logged In": "وارد شدید",
		"Password Reset": "بازنشانی گذرواژه",
		"OTP App": "برنامه رمز یک‌بارمصرف",
		"SMS": "پیامک",
		"No App": "بدون برنامه",
		"Search or type a command": "جستجو یا اجرای دستور",
		"Search": "جستجو",
		"Notifications": "اعلان‌ها",
		"Help": "راهنما",
		"Profile": "نمایه کاربری",
		"My Settings": "تنظیمات من",
		"Log out": "خروج",
		"Home": "خانه",
		"Accounting": "حسابداری",
		"Accounts": "حسابداری",
		"Stock": "انبار",
		"Buying": "خرید",
		"Selling": "فروش",
		"CRM": "مدیریت ارتباط با مشتری",
		"Projects": "پروژه‌ها",
		"Manufacturing": "تولید",
		"Assets": "دارایی‌ها",
		"HR": "منابع انسانی",
		"Framework": "زیرساخت",
		"Frappe": "RQland",
		"Frappe Framework": "چارچوب فنی",
		"Frappe CRM": "فروش و ارتباطات مشتری",
		"Frappe Builder": "سازنده وب",
		"Frappe Drive": "اسناد و فایل‌ها",
		"Frappe HR": "منابع انسانی",
		"Frappe Learning": "آموزش و توانمندسازی",
		"Helpdesk": "میز خدمت",
		"Wiki": "دانش‌نامه",
		"Lending": "تسهیلات",
		"Education": "آموزش سازمانی",
		"My Workspaces": "محیط‌های کاری من",
		"Organization": "سازمان",
		"Learning": "برنامه‌های آموزشی",
		"RQ Project Control": "مدیریت و کنترل پروژه",
		"ERPNext Settings": "تنظیمات سامانه",
		"Subcontracting": "پیمانکاری جزء",
		"ERPNext": "RQ ERP",
		"ERPNEXT": "RQ ERP",
		"ERP Next": "RQ ERP",
		"RQ ERP": "RQ ERP",
		"Nexora": "نکسورا",
		"NXerp": "ان‌ایکس‌ای‌آرپی",
		"Nexora Operations": "عملیات نکسورا",
		"AgriERP": "اگری‌ای‌آرپی",
		"AgriERP Operations": "عملیات اگری‌ای‌آرپی",
		"AgriERP Command Center": "مرکز فرماندهی اگری‌ای‌آرپی",
		"Core AgriERP": "هسته اگری‌ای‌آرپی",
		"Modules and Settings": "ماژول‌ها و تنظیمات",
		"Master Data": "داده‌های پایه",
		"Crop and Greenhouse": "زراعت و گلخانه",
		"Poultry, Livestock, Aqua": "طیور، دام و آبزیان",
		"Operations": "عملیات",
		"Traceability and Quality": "رهگیری و کیفیت",
		"IoT, Twin, AI": "اینترنت اشیا، دوقلوی دیجیتال و هوش مصنوعی",
		"Farms": "فارم‌ها",
		"Sites": "سایت‌ها",
		"Facilities": "تأسیسات",
		"Production Units": "واحدهای تولید",
		"Fields": "مزارع",
		"Plots": "قطعات",
		"Greenhouses": "گلخانه‌ها",
		"Crops": "محصولات کشاورزی",
		"Crop Varieties": "ارقام محصول",
		"Houses": "سالن‌ها",
		"Flocks": "گله‌های طیور",
		"Herds": "گله‌های دام",
		"Animals": "دام‌ها",
		"Ponds": "استخرها",
		"Production Cycles": "دوره‌های تولید",
		"Feed Logs": "ثبت خوراک",
		"Mortality Logs": "ثبت تلفات",
		"Medication Logs": "ثبت دارو",
		"Vaccination Logs": "ثبت واکسیناسیون",
		"Growth Sampling": "نمونه‌گیری رشد",
		"Harvest Logs": "ثبت برداشت",
		"Traceability Events": "رویدادهای رهگیری",
		"Lot Genealogy": "تبارشناسی بچ",
		"Product Passports": "شناسنامه‌های محصول",
		"Passport Publishing": "انتشار شناسنامه",
		"Passport Publication Queue": "صف انتشار شناسنامه",
		"KPI Snapshots": "نمایه‌های KPI",
		"Devices": "دستگاه‌ها",
		"Sensors": "سنسورها",
		"Telemetry": "تله‌متری",
		"Telemetry Readings": "داده‌های تله‌متری",
		"Twin Profiles": "پروفایل‌های دوقلوی دیجیتال",
		"AI Assistants": "دستیارهای هوش مصنوعی",
		"AI Advisory": "مشاوره هوشمند",
		"Advisory Requests": "درخواست‌های مشاوره",
		"Active Farms": "فارم‌های فعال",
		"Active Cycles": "دوره‌های فعال",
		"Passport Review": "بازبینی شناسنامه",
		"Published Passports": "شناسنامه‌های منتشرشده",
		"Suspended Passports": "شناسنامه‌های تعلیق‌شده",
		"AI Review Queue": "صف بازبینی هوش مصنوعی",
		"IoT Readings": "داده‌های IoT",
		"Users": "کاربران",
		"Settings": "تنظیمات",
		"Tools": "ابزارها",
		"Build": "ساخت",
		"Integrations": "یکپارچه‌سازی",
		"Website": "وب‌سایت",
		"Reports": "گزارش‌ها",
		"Report": "گزارش",
		"Documents": "مستندات",
		"Document": "سند",
		"Dashboard": "داشبورد",
		"Chart": "نمودار",
		"Charts": "نمودارها",
		"Kanban": "کانبان",
		"List": "فهرست",
		"Form": "فرم",
		"New": "جدید",
		"Save": "ذخیره",
		"Submit": "ثبت نهایی",
		"Cancel": "لغو",
		"Delete": "حذف",
		"Edit": "ویرایش",
		"Print": "چاپ",
		"Export": "خروجی",
		"Import": "ورود داده",
		"Refresh": "بازخوانی",
		"Reload": "بارگذاری دوباره",
		"Close": "بستن",
		"Apply": "اعمال",
		"Filter": "فیلتر",
		"Filters": "فیلترها",
		"Menu": "منو",
		"More": "بیشتر",
		"Actions": "اقدام‌ها",
		"Select": "انتخاب",
		"Select All": "انتخاب همه",
		"Name": "نام",
		"Title": "عنوان",
		"Status": "وضعیت",
		"Owner": "مالک",
		"Modified": "ویرایش‌شده",
		"Created": "ایجادشده",
		"Welcome": "خوش آمدید",
		"Language": "زبان",
		"Country": "کشور",
		"Currency": "واحد پول",
		"Time Zone": "منطقه زمانی",
		"Date Format": "قالب تاریخ",
		"Number Format": "قالب عدد",
		"First Day of the Week": "اولین روز هفته",
		"Sunday": "یکشنبه",
		"Saturday": "شنبه",
		"Persian": "فارسی",
		"Iran": "ایران",
		"Iranian Rial": "ریال ایران",
		"IRR": "ریال ایران",
		"Asia/Tehran": "آسیا/تهران",
		"Getting Started": "شروع کار",
		"Let's Get Started": "شروع کار",
		"Accounting Onboarding": "راه‌اندازی حسابداری",
		"Organization Onboarding": "راه‌اندازی سازمان",
		"Projects Onboarding": "راه‌اندازی پروژه‌ها",
		"Stock Onboarding": "راه‌اندازی انبار",
		"Selling Onboarding": "راه‌اندازی فروش",
		"Buying Onboarding": "راه‌اندازی خرید",
		"steps completed": "گام تکمیل‌شده",
		"steps completed 0/6": "۰ از ۶ گام تکمیل شده",
		"step": "گام",
		"steps": "گام‌ها",
		"Skip All": "رد کردن همه",
		"Skip": "رد کردن",
		"Dismiss": "بستن",
		"completed": "تکمیل شده",
		"Configure Chart of Accounts": "پیکربندی نمودار حساب‌ها",
		"Setup Sales Taxes": "تنظیم مالیات‌های فروش",
		"Create Sales Invoice": "ایجاد فاکتور فروش",
		"Create Payment Entry": "ایجاد ثبت پرداخت",
		"View Balance Sheet": "مشاهده ترازنامه",
		"Review Accounts Settings": "بازبینی تنظیمات حساب‌ها",
		"Configure": "پیکربندی",
		"Setup": "تنظیم",
		"View": "مشاهده",
		"Create": "ایجاد",
		"Balance Sheet": "ترازنامه",
		"Chart of Accounts": "نمودار حساب‌ها",
		"Sales Taxes": "مالیات‌های فروش",
		"Sales Invoice": "فاکتور فروش",
		"Payment Entry": "ثبت پرداخت",
		"Accounts Settings": "تنظیمات حساب‌ها",
		"Outgoing Payment": "پرداخت خروجی",
		"Incoming Payment": "پرداخت ورودی",
		"Incoming Bills": "صورتحساب‌های ورودی",
		"Outgoing Bills": "صورتحساب‌های خروجی",
		"Payment": "پرداخت",
		"Payments": "پرداخت‌ها",
		"Bills": "صورتحساب‌ها",
		"Invoice": "فاکتور",
		"Invoices": "فاکتورها",
		"Customer": "مشتری",
		"Customers": "مشتریان",
		"Supplier": "تأمین‌کننده",
		"Suppliers": "تأمین‌کنندگان",
		"Company": "شرکت",
		"Fiscal Year": "سال مالی",
		"Cost Center": "مرکز هزینه",
		"Budget": "بودجه",
		"Bank": "بانک",
		"Bank Account": "حساب بانکی",
		"Payment Terms": "شرایط پرداخت",
		"Opening Invoice Creation Tool": "ابزار ایجاد فاکتور افتتاحیه",
		"Period Closing Voucher": "سند بستن دوره",
		"Account": "حساب",
		"Accounts Payable": "حساب‌های پرداختنی",
		"Accounts Receivable": "حساب‌های دریافتنی",
		"Accounts Payable Ageing": "سررسید حساب‌های پرداختنی",
		"Accounts Receivable Ageing": "سررسید حساب‌های دریافتنی",
		"Sales": "فروش",
		"Purchase": "خرید",
		"Purchase Invoice": "فاکتور خرید",
		"Sales Invoices": "فاکتورهای فروش",
		"Purchase Invoices": "فاکتورهای خرید",
		"Total Income": "کل درآمد",
		"Total Expense": "کل هزینه",
		"Profit This Year": "سود امسال",
		"This Year": "امسال",
		"Last Year": "سال گذشته",
		"Monthly": "ماهیانه",
		"Yearly": "سالانه",
		"Daily": "روزانه",
		"Week": "هفته",
		"Month": "ماه",
		"Year": "سال",
		"General Ledger": "دفتر کل",
		"Project Name": "نام پروژه",
		"Project Type": "نوع پروژه",
		"From Template": "از الگو",
		"% Complete Method": "روش محاسبه درصد پیشرفت",
		"Task Completion": "تکمیل وظایف",
		"Task Progress": "پیشرفت وظایف",
		"Task Weight": "وزن وظایف",
		"Manual": "دستی",
		"Is Active": "وضعیت فعالیت",
		"Expected Start Date": "تاریخ شروع برنامه‌ریزی‌شده",
		"Expected End Date": "تاریخ پایان برنامه‌ریزی‌شده",
		"Actual Start Date (via Timesheet)": "تاریخ شروع واقعی از کارکرد",
		"Actual End Date (via Timesheet)": "تاریخ پایان واقعی از کارکرد",
		"Actual Time in Hours (via Timesheet)": "زمان واقعی به ساعت از کارکرد",
		"Estimated Cost": "هزینه برآوردی",
		"Total Costing Amount (via Timesheet)": "جمع بهای کارکرد",
		"Total Expense Claim (via Expense Claims)": "جمع درخواست‌های هزینه",
		"Total Expense Claim (via Expense Claim)": "جمع درخواست‌های هزینه",
		"Total Purchase Cost (via Purchase Invoice)": "جمع هزینه خرید",
		"Total Sales Amount (via Sales Order)": "جمع مبلغ فروش",
		"Total Billable Amount (via Timesheet)": "جمع مبلغ قابل صورت‌حساب",
		"Total Billed Amount (via Sales Invoice)": "جمع مبلغ صورت‌حساب‌شده",
		"Total Consumed Material Cost (via Stock Entry)": "جمع هزینه مواد مصرفی",
		"Default Cost Center": "مرکز هزینه پیش‌فرض",
		"Gross Margin": "حاشیه سود ناخالص",
		"Gross Margin %": "درصد حاشیه سود ناخالص",
		"Task Description": "شرح وظیفه",
		"Parent Task": "وظیفه والد",
		"Dependent Tasks": "وظایف وابسته",
		"Expected Time (in hours)": "زمان برآوردی به ساعت",
		"Begin On (Days)": "شروع در روز",
		"Duration (Days)": "مدت به روز",
		"% Progress": "درصد پیشرفت",
		"Is Milestone": "نقطه عطف",
		"Review Date": "تاریخ بازبینی",
		"Closing Date": "تاریخ بسته‌شدن",
		"0/6": "۰/۶",
		"0%": "۰٪",
	};

	function applyProfileTextMap() {
		var localization = getBootLocalization();
		var product = localization.persian_product_name || localization.product_name || "RQ ERP";
		var service = localization.persian_service_name || localization.service_name || product;
		textMap.ERPNext = product;
		textMap.ERPNEXT = product;
		textMap["ERP Next"] = product;
		textMap["ERPNext Settings"] = "تنظیمات " + product;
		textMap["تنظیمات سامانه"] = "تنظیمات " + product;
		if (localization.product_name !== "RQ ERP") {
			textMap["RQ ERP"] = service;
		}
	}

	var monthMap = {
		Jan: "ژانویه",
		Feb: "فوریه",
		Mar: "مارس",
		Apr: "آوریل",
		May: "مه",
		Jun: "ژوئن",
		Jul: "ژوئیه",
		Aug: "اوت",
		Sep: "سپتامبر",
		Oct: "اکتبر",
		Nov: "نوامبر",
		Dec: "دسامبر",
		January: "ژانویه",
		February: "فوریه",
		March: "مارس",
		April: "آوریل",
		June: "ژوئن",
		July: "ژوئیه",
		August: "اوت",
		September: "سپتامبر",
		October: "اکتبر",
		November: "نوامبر",
		December: "دسامبر",
	};
	var gregorianMonthNumbers = {
		Jan: 1,
		January: 1,
		Feb: 2,
		February: 2,
		Mar: 3,
		March: 3,
		Apr: 4,
		April: 4,
		May: 5,
		Jun: 6,
		June: 6,
		Jul: 7,
		July: 7,
		Aug: 8,
		August: 8,
		Sep: 9,
		September: 9,
		Oct: 10,
		October: 10,
		Nov: 11,
		November: 11,
		Dec: 12,
		December: 12,
	};
	var jalaliMonthNames = [
		"فروردین",
		"اردیبهشت",
		"خرداد",
		"تیر",
		"مرداد",
		"شهریور",
		"مهر",
		"آبان",
		"آذر",
		"دی",
		"بهمن",
		"اسفند",
	];

	function translateKnownFragments(value) {
		var translated = value;
		Object.keys(textMap)
			.sort(function (a, b) {
				return b.length - a.length;
			})
			.forEach(function (sourceText) {
				if (translated.indexOf(sourceText) > -1) {
					translated = translated.split(sourceText).join(textMap[sourceText]);
				}
			});
		return translated;
	}

	function localizeFiscalYearRanges(value) {
		return value.replace(/\b(20\d{2})-(20\d{2})\b/g, function (_match, start, end) {
			return localizeDigits(String(Number(start) - 621) + "-" + String(Number(end) - 621));
		});
	}

	function localizeMonthNames(value) {
		return value.replace(/\b(January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/g, function (match) {
			return monthMap[match] || match;
		});
	}

	function localizeGregorianMonthLabels(value) {
		return value.replace(
			/\b(January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(20\d{2})\b/g,
			function (_match, monthName, year) {
				var month = gregorianMonthNumbers[monthName];
				var jalali = toJalali(String(year) + "-" + String(month).padStart(2, "0") + "-01");
				if (!jalali) {
					return localizeDigits(_match);
				}
				return jalaliMonthNames[jalali.month - 1] + " " + localizeDigits(jalali.year);
			}
		);
	}

	function localizeTextFragments(value) {
		if (!value) {
			return value;
		}
		var output = translateKnownFragments(value);
		output = output.replace(/(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}[-/]\d{1,2}[-/]\d{4})/g, function (match) {
			var jalali = toJalali(match);
			return jalali ? formatDate(jalali, true) : localizeDigits(match);
		});
		output = localizeFiscalYearRanges(output);
		output = localizeGregorianMonthLabels(output);
		output = localizeMonthNames(output);
		return localizeDigits(output);
	}

	function translateTextNode(node) {
		var original = node.nodeValue;
		var source = original.replace(/\s+/g, " ").trim();
		if (!source) {
			return;
		}
		if (textMap[source]) {
			node.nodeValue = original.replace(source, textMap[source]);
			return;
		}
		var translated = localizeTextFragments(original);
		if (translated !== original) {
			node.nodeValue = translated;
		}
	}

	function setTextContentIfChanged(element, value) {
		if (element && element.textContent !== value) {
			element.textContent = value;
		}
	}

	function setAttributeIfChanged(element, name, value) {
		var normalized = String(value);
		if (element && element.getAttribute(name) !== normalized) {
			element.setAttribute(name, normalized);
		}
	}

	function queryAllWithin(root, selector) {
		var scope = root && root.querySelectorAll ? root : document;
		var elements = [];
		if (scope.nodeType === Node.ELEMENT_NODE && scope.matches(selector)) {
			elements.push(scope);
		}
		return elements.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
	}

	function shouldPreserveLtr(parent, text) {
		if (!parent) {
			return true;
		}
		if (
			parent.closest(
				"script, style, textarea, input, code, pre, bdi, [dir='ltr'], .rqerp-ltr, .text-monospace, .monospace, .ace_editor, .CodeMirror, .ql-code-block"
			)
		) {
			return true;
		}
		return /(https?:\/\/|www\.|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/.test(text || "");
	}

	function translateVisibleText(root) {
		if (!root) {
			return;
		}
		var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
			acceptNode: function (node) {
				if (!node.nodeValue || !node.nodeValue.trim()) {
					return NodeFilter.FILTER_REJECT;
				}
				var parent = node.parentElement;
				if (shouldPreserveLtr(parent, node.nodeValue)) {
					return NodeFilter.FILTER_REJECT;
				}
				return NodeFilter.FILTER_ACCEPT;
			},
		});
		var nodes = [];
		while (walker.nextNode()) {
			nodes.push(walker.currentNode);
		}
		nodes.forEach(translateTextNode);
	}

	function localizePlaceholders(root) {
		var localization = getBootLocalization();
		var loginIdentity = localization.product_name === "NXerp" ? "name@nexora.rqland.ir" : "name@rqland.ir";
		var placeholders = {
			login_email: loginIdentity,
			login_password: "گذرواژه",
			"navbar-search": "جستجو یا اجرای دستور",
		};
		Object.keys(placeholders).forEach(function (id) {
			var input = document.getElementById(id);
			if (input) {
				setAttributeIfChanged(input, "placeholder", placeholders[id]);
			}
		});
		queryAllWithin(root, 'input[placeholder="Search or type a command"], input[placeholder="Search"]').forEach(function (input) {
			setAttributeIfChanged(input, "placeholder", "جستجو یا اجرای دستور");
		});
	}

	function localizeAttributes(root) {
		var selector = "[title], [aria-label], [data-original-title], [placeholder]";
		queryAllWithin(root, selector).forEach(function (element) {
			["title", "aria-label", "data-original-title", "placeholder"].forEach(function (name) {
				var current = element.getAttribute(name);
				if (!current || shouldPreserveLtr(element, current)) {
					return;
				}
				var localized = localizeTextFragments(current);
				if (localized !== current) {
					setAttributeIfChanged(element, name, localized);
				}
			});
		});
	}

	function localizeSelectOptionText(select) {
		if (!select) {
			return;
		}
		Array.prototype.forEach.call(select.options || [], function (option) {
			var source = option.textContent.replace(/\s+/g, " ").trim();
			if (textMap[source]) {
				setTextContentIfChanged(option, textMap[source]);
			}
			if (option.value === "fa" || option.value === "فارسی") {
				setTextContentIfChanged(option, "فارسی");
			}
			if (option.value === "IRR") {
				setTextContentIfChanged(option, "ریال ایران");
			}
			if (option.value === "Asia/Tehran") {
				setTextContentIfChanged(option, "آسیا/تهران");
			}
		});
	}

	function preferSetupDefaults(root) {
		var selectors = [
			'select[data-fieldname="language"]',
			'select[data-fieldname="country"]',
			'select[data-fieldname="currency"]',
			'select[data-fieldname="timezone"]',
			'select[data-fieldname="time_zone"]',
			'select[name="language"]',
			'select[name="country"]',
			'select[name="currency"]',
			'select[name="timezone"]',
			'select[name="time_zone"]',
		];
		queryAllWithin(root, selectors.join(",")).forEach(function (select) {
			localizeSelectOptionText(select);
			var fieldname = select.getAttribute("data-fieldname") || select.name || "";
			var desired = "";
			if (fieldname === "language") {
				desired = "fa";
			} else if (fieldname === "country") {
				desired = "Iran";
			} else if (fieldname === "currency") {
				desired = "IRR";
			} else if (fieldname === "timezone" || fieldname === "time_zone") {
				desired = "Asia/Tehran";
			}
			if (
				desired &&
				select.value !== desired &&
				Array.prototype.some.call(select.options, function (option) {
					return option.value === desired;
				})
			) {
				select.value = desired;
				select.dispatchEvent(new Event("change", { bubbles: true }));
			}
		});
	}

	function applyLoginBranding(root) {
		if (!document.body || document.body.getAttribute("data-path") !== "login") {
			return;
		}
		var localization = getBootLocalization();
		var product = localization.persian_product_name || localization.product_name || "RQ ERP";
		var identity = localization.identity_provider_name || "RQidentity";
		var loginTitle = "ورود به " + product;
		if (document.title !== loginTitle) {
			document.title = loginTitle;
		}
		queryAllWithin(root, ".page-card-head h4").forEach(function (heading) {
			setTextContentIfChanged(heading, loginTitle);
		});
		queryAllWithin(root, ".page-card-subtitle").forEach(function (subtitle) {
			setTextContentIfChanged(subtitle, "برای ادامه، با حساب " + identity + " وارد شوید.");
		});
		queryAllWithin(root, ".btn-rqidentity_zitadel").forEach(function (button) {
			setTextContentIfChanged(button, "ورود با " + identity);
		});
		queryAllWithin(root, 'img[src*="/assets/erpnext/images/erpnext-logo.svg"], img[src*="erpnext-logo.svg"]').forEach(function (image) {
			image.removeAttribute("src");
			image.setAttribute("alt", product);
			image.classList.add("rqerp-hidden-upstream-logo");
		});
	}

	function normalizeDigits(value) {
		return String(value || "").replace(/[۰-۹٠-٩]/g, function (digit) {
			var persianIndex = persianDigits.indexOf(digit);
			if (persianIndex > -1) {
				return asciiDigits[persianIndex];
			}
			return String("٠١٢٣٤٥٦٧٨٩".indexOf(digit));
		});
	}

	function localizeDigits(value) {
		return String(value || "").replace(/[0-9]/g, function (digit) {
			return persianDigits[Number(digit)];
		});
	}

	function isGregorianLeap(year) {
		return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}

	function isJalaliLeap(year) {
		var breaks = [-61, 9, 38, 199, 426, 686, 756, 818, 1111, 1181, 1210, 1635, 2060, 2097, 2192, 2262, 2324, 2394, 2456, 3178];
		var jump = 0;
		var jp = breaks[0];
		for (var i = 1; i < breaks.length; i += 1) {
			var jm = breaks[i];
			jump = jm - jp;
			if (year < jm) {
				break;
			}
			jp = jm;
		}
		var n = year - jp;
		if (jump - n < 6) {
			n = n - jump + Math.trunc((jump + 4) / 33) * 33;
		}
		var leap = ((n + 1) % 33 - 1) % 4;
		if (leap === -1) {
			leap = 4;
		}
		return leap === 0;
	}

	function parseDateParts(value) {
		var normalized = normalizeDigits(value).trim().replace(/[./_]/g, "-");
		var match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
		if (!match) {
			match = normalized.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
			if (!match) {
				return null;
			}
			return {
				year: Number(match[3]),
				month: Number(match[2]),
				day: Number(match[1]),
			};
		}
		return {
			year: Number(match[1]),
			month: Number(match[2]),
			day: Number(match[3]),
		};
	}

	function toJalali(value) {
		var parts = parseDateParts(value);
		if (!parts || parts.year < 1600 || parts.month < 1 || parts.month > 12 || parts.day < 1) {
			return null;
		}
		var maxGregorianDay = gregorianDaysInMonth[parts.month - 1] + (parts.month === 2 && isGregorianLeap(parts.year) ? 1 : 0);
		if (parts.day > maxGregorianDay) {
			return null;
		}

		var gy = parts.year;
		var gm = parts.month;
		var gd = parts.day;
		var jy;
		if (gy > 1600) {
			jy = 979;
			gy -= 1600;
		} else {
			jy = 0;
			gy -= 621;
		}
		var gy2 = gm > 2 ? gy + 1 : gy;
		var gdm = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
		var days =
			365 * gy +
			Math.floor((gy2 + 3) / 4) -
			Math.floor((gy2 + 99) / 100) +
			Math.floor((gy2 + 399) / 400) -
			80 +
			gd +
			gdm[gm - 1];
		jy += 33 * Math.floor(days / 12053);
		days %= 12053;
		jy += 4 * Math.floor(days / 1461);
		days %= 1461;
		if (days > 365) {
			jy += Math.floor((days - 1) / 365);
			days = (days - 1) % 365;
		}
		var jm = days < 186 ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
		var jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);

		return {
			year: jy,
			month: jm,
			day: jd,
		};
	}

	function fromJalali(value) {
		var parts = parseDateParts(value);
		if (!parts || parts.year < 1200 || parts.year > 1600 || parts.month < 1 || parts.month > 12 || parts.day < 1) {
			return null;
		}

		var maxDay = parts.month === 12 ? (isJalaliLeap(parts.year) ? 30 : 29) : jalaliDaysInMonth[parts.month - 1];
		if (parts.day > maxDay) {
			return null;
		}

		var jy = parts.year;
		var jm = parts.month;
		var jd = parts.day;
		var gy = jy <= 979 ? 621 : 1600;
		jy -= jy <= 979 ? 0 : 979;
		var days =
			365 * jy +
			Math.floor(jy / 33) * 8 +
			Math.floor((jy % 33 + 3) / 4) +
			78 +
			jd +
			(jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
		gy += 400 * Math.floor(days / 146097);
		days %= 146097;
		if (days > 36524) {
			days -= 1;
			gy += 100 * Math.floor(days / 36524);
			days %= 36524;
			if (days >= 365) {
				days += 1;
			}
		}
		gy += 4 * Math.floor(days / 1461);
		days %= 1461;
		if (days > 365) {
			gy += Math.floor((days - 1) / 365);
			days = (days - 1) % 365;
		}
		var gd = days + 1;
		var gregorianMonths = [0, 31, isGregorianLeap(gy) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var gm;
		for (gm = 1; gm <= 12; gm += 1) {
			if (gd <= gregorianMonths[gm]) {
				break;
			}
			gd -= gregorianMonths[gm];
		}

		return {
			year: gy,
			month: gm,
			day: gd,
		};
	}

	function formatDate(parts, localized) {
		if (!parts) {
			return "";
		}
		var text = [
			String(parts.year).padStart(4, "0"),
			String(parts.month).padStart(2, "0"),
			String(parts.day).padStart(2, "0"),
		].join("-");
		return localized ? localizeDigits(text.replace(/-/g, "/")) : text;
	}

	function formatGregorianForStorage(parts) {
		return formatDate(parts, false);
	}

	function isLikelyJalali(value) {
		var parts = parseDateParts(value);
		return Boolean(parts && parts.year >= 1200 && parts.year <= 1600);
	}

	function splitDateTimeValue(value) {
		var normalized = normalizeDigits(value).trim();
		var match = normalized.match(
			/^(\d{4}[./_-]\d{1,2}[./_-]\d{1,2}|\d{1,2}[./_-]\d{1,2}[./_-]\d{4})(?:[ T](.+))?$/
		);
		if (!match) {
			return null;
		}
		return {
			date: match[1],
			time: (match[2] || "").trim(),
		};
	}

	function formatJalaliUserValue(value) {
		var split = splitDateTimeValue(value);
		if (!split) {
			return null;
		}
		var jalali = toJalali(split.date);
		if (!jalali) {
			return null;
		}
		var output = formatDate(jalali, true);
		if (split.time) {
			output += " " + localizeDigits(split.time);
		}
		return output;
	}

	function formatGregorianUserValue(value) {
		var split = splitDateTimeValue(value);
		if (!split || !isLikelyJalali(split.date)) {
			return null;
		}
		var gregorian = fromJalali(split.date);
		if (!gregorian) {
			return null;
		}
		var output = formatGregorianForStorage(gregorian);
		if (split.time) {
			output += " " + normalizeDigits(split.time);
		}
		return output;
	}

	function markNativeFrappeDatePicker(input) {
		if (!window.jQuery || !input) {
			return;
		}
		var picker = window.jQuery(input).data("datepicker");
		if (picker && picker.$datepicker) {
			picker.$datepicker.addClass("rqerp-native-datepicker");
		}
	}

	function updateDateControl(control) {
		if (!control) {
			return;
		}

		var input = control.querySelector("input");
		if (!input) {
			return;
		}

		markNativeFrappeDatePicker(input);
		if (input.dataset.rqerpJalaliReady === "1") {
			return;
		}

		var fieldtype = control.getAttribute("data-fieldtype") || "";
		input.dataset.rqerpJalaliReady = "1";
		control.classList.add("rqerp-jalali-control");
		input.setAttribute("data-jdp", "");
		input.setAttribute("data-jdp-mode", fieldtype === "Date Range" ? "range" : "single");
		input.setAttribute("data-jdp-has-second", fieldtype === "Datetime" ? "true" : "false");
		if (fieldtype !== "Datetime") {
			input.setAttribute("data-jdp-only-date", "");
		}
		input.setAttribute("inputmode", "numeric");
		input.setAttribute("placeholder", input.getAttribute("placeholder") || "۱۴۰۵/۰۵/۰۶");
		input.setAttribute("aria-haspopup", "dialog");
		input.setAttribute("aria-label", fieldtype === "Date Range" ? "بازه تاریخ شمسی" : "تاریخ شمسی");
		input.addEventListener("focus", function () {
			window.setTimeout(function () {
				markNativeFrappeDatePicker(input);
			}, 0);
		});
	}

	function applyJalaliDateControls(root) {
		var localization = getBootLocalization();
		if (localization.calendar_display !== "jalali" && document.documentElement.lang !== "fa") {
			return;
		}
		var selector =
			'.frappe-control[data-fieldtype="Date"], .frappe-control[data-fieldtype="Datetime"], .frappe-control[data-fieldtype="Date Range"], [data-fieldtype="Date"].frappe-control, [data-fieldtype="Datetime"].frappe-control, [data-fieldtype="Date Range"].frappe-control';
		var controls = queryAllWithin(root, selector);
		if (root.nodeType === Node.ELEMENT_NODE && root.closest) {
			var parentControl = root.closest(selector);
			if (parentControl && controls.indexOf(parentControl) === -1) {
				controls.push(parentControl);
			}
		}
		controls.forEach(updateDateControl);
	}

	function localizeDateTextNodes(root) {
		if (!root) {
			return;
		}
		var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
			acceptNode: function (node) {
				var text = node.nodeValue || "";
				if (!/\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}[-/]\d{1,2}[-/]\d{4}/.test(text)) {
					return NodeFilter.FILTER_REJECT;
				}
				var parent = node.parentElement;
				if (shouldPreserveLtr(parent, text)) {
					return NodeFilter.FILTER_REJECT;
				}
				return NodeFilter.FILTER_ACCEPT;
			},
		});
		var nodes = [];
		while (walker.nextNode()) {
			nodes.push(walker.currentNode);
		}
		nodes.forEach(function (node) {
			node.nodeValue = node.nodeValue.replace(/(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}[-/]\d{1,2}[-/]\d{4})/g, function (match) {
				var jalali = toJalali(match);
				return jalali ? formatDate(jalali, true) : localizeDigits(match);
			});
		});
	}

	function localizePlainNumbers(root) {
		if (!root) {
			return;
		}
		var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
			acceptNode: function (node) {
				var text = node.nodeValue || "";
				if (!/[0-9]|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|ERPNext|ERPNEXT/.test(text)) {
					return NodeFilter.FILTER_REJECT;
				}
				var parent = node.parentElement;
				if (shouldPreserveLtr(parent, text)) {
					return NodeFilter.FILTER_REJECT;
				}
				return NodeFilter.FILTER_ACCEPT;
			},
		});
		var nodes = [];
		while (walker.nextNode()) {
			nodes.push(walker.currentNode);
		}
		nodes.forEach(function (node) {
			var text = node.nodeValue;
			var translated = localizeTextFragments(text);
			if (translated !== text) {
				node.nodeValue = translated;
			}
		});
	}

	function localizeNumericElements(root) {
		if (!root) {
			return;
		}
		var selector = ".number, .number-widget-box .number, .widget .number, .indicator-pill, .progress-bar, .chart-label, .axis, .tick text, svg text, .frappe-chart text";
		var elements = queryAllWithin(root, selector);
		elements.forEach(function (element) {
			if (!element || !element.textContent || !/[0-9]|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|ERPNext|ERPNEXT/.test(element.textContent)) {
				return;
			}
			var current = element.textContent;
			var localized = localizeTextFragments(current);
			if (localized !== current) {
				element.textContent = localized;
			}
		});
	}

	function patchFrappeDateConversion() {
		if (!window.frappe || !frappe.datetime || frappe.datetime.rqerpJalaliPatched) {
			return;
		}
		var originalStrToUser = frappe.datetime.str_to_user;
		var originalUserToStr = frappe.datetime.user_to_str;
		if (typeof originalStrToUser !== "function" || typeof originalUserToStr !== "function") {
			return;
		}
		frappe.datetime.str_to_user = function (value, onlyTime) {
			var rendered = originalStrToUser.apply(this, arguments);
			if (onlyTime) {
				return localizeDigits(rendered);
			}
			return formatJalaliUserValue(rendered) || formatJalaliUserValue(value) || localizeDigits(rendered);
		};
		frappe.datetime.user_to_str = function (value, onlyTime) {
			if (!value) {
				return originalUserToStr.apply(this, arguments);
			}
			var normalized = normalizeDigits(value);
			if (!onlyTime) {
				normalized = formatGregorianUserValue(normalized) || normalized;
			}
			return originalUserToStr.call(this, normalized, onlyTime);
		};
		frappe.datetime.rqerpJalaliPatched = true;
	}

	function initializeJalaliDatePicker() {
		if (!window.jalaliDatepicker || document.documentElement.dataset.rqerpJalaliPicker === "1") {
			return;
		}
		window.jalaliDatepicker.startWatch({
			selector: "body.rqerp-persian input[data-jdp]",
			date: true,
			time: true,
			hasSecond: "attr",
			mode: "attr",
			position: "right",
			persianDigits: true,
			autoReadOnlyInput: false,
			hideAfterChange: true,
			hideAfterChangeWithTime: false,
			showTodayBtn: true,
			showEmptyBtn: true,
			showCloseBtn: true,
			showSelectTimeBtnAlways: true,
			rangeSeparator: " تا ",
			separatorChars: {
				date: "/",
				between: " ",
				time: ":",
				targetDate: "-",
				targetBetween: " ",
				targetTime: ":",
			},
		});
		document.documentElement.dataset.rqerpJalaliPicker = "1";
	}

	function makeJalaliPickerButton(element, label) {
		if (!element) {
			return;
		}
		setAttributeIfChanged(element, "role", "button");
		setAttributeIfChanged(element, "tabindex", element.classList.contains("disabled-day") ? "-1" : "0");
		setAttributeIfChanged(element, "aria-label", label || element.textContent.trim());
		if (!element.dataset.rqerpKeyboardReady) {
			element.dataset.rqerpKeyboardReady = "1";
			element.addEventListener("keydown", function (event) {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					element.click();
				}
			});
		}
	}

	function enhanceJalaliPickerAccessibility(root) {
		queryAllWithin(root, "jdp-container").forEach(function (container) {
			if (!container.id) {
				container.id = "rqerp-jalali-datepicker";
			}
			setAttributeIfChanged(container, "role", "dialog");
			setAttributeIfChanged(container, "aria-label", "تقویم شمسی");
			setAttributeIfChanged(container, "lang", "fa");
			setAttributeIfChanged(container, "dir", "rtl");

			queryAllWithin(container, ".jdp-day").forEach(function (day) {
				makeJalaliPickerButton(day, "روز " + day.textContent.trim());
				setAttributeIfChanged(day, "aria-selected", day.classList.contains("selected") ? "true" : "false");
			});
			queryAllWithin(container, ".jdp-month, .jdp-btn-today, .jdp-btn-empty, .jdp-btn-close").forEach(function (button) {
				makeJalaliPickerButton(button);
			});
			queryAllWithin(container, ".jdp-icon-plus").forEach(function (button) {
				makeJalaliPickerButton(button, "افزایش");
			});
			queryAllWithin(container, ".jdp-icon-minus").forEach(function (button) {
				makeJalaliPickerButton(button, "کاهش");
			});
		});
		queryAllWithin(root, "jdp-overlay").forEach(function (overlay) {
			setAttributeIfChanged(overlay, "aria-hidden", "true");
		});
	}

	function cssString(value) {
		return '"' + String(value || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
	}

	function applyProductBranding() {
		var localization = getBootLocalization();
		var product = localization.persian_product_name || localization.product_name || "RQ ERP";
		document.documentElement.style.setProperty("--rqerp-product-suffix", cssString(" / " + product));
		if (document.body) {
			document.body.dataset.rqerpProduct = localization.product_name || product;
		}
	}

	function exposeProductWorkspace(root) {
		var localization = getBootLocalization();
		var product = localization.persian_product_name || localization.product_name || "RQ ERP";
		var labels = [
			product,
			localization.product_name,
			localization.service_name,
			localization.persian_service_name,
			"RQ ERP",
			"Nexora Operations",
			"عملیات نکسورا",
			"Nexora",
			"نکسورا",
			"AgriERP Operations",
			"عملیات اگری‌ای‌آرپی",
			"AgriERP",
			"اگری‌ای‌آرپی",
		].filter(Boolean);
		queryAllWithin(root, ".standard-sidebar-item, .workspace-sidebar-item, .desk-sidebar-item, .sidebar-item, .workspace-link, .module-link, .desk-module").forEach(function (item) {
			if (labels.some(function (label) { return (item.textContent || "").indexOf(label) > -1; })) {
				item.classList.add("rqerp-product-entry");
				if ((item.textContent || "").indexOf("نکسورا") > -1 || (item.textContent || "").indexOf("Nexora") > -1) {
					item.classList.add("rqerp-nexora-entry");
				}
				item.style.display = "";
			}
		});
	}

	function isPersianContext() {
		var localization = getBootLocalization();
		var isLogin = document.body && document.body.getAttribute("data-path") === "login";
		return localization.language === "fa" || document.documentElement.lang === "fa" || isLogin;
	}

	function processPersianRoot(root) {
		if (!root || !isPersianContext()) {
			return;
		}

		var scope = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
		if (!scope || (scope.closest && scope.closest("script, style, code, pre"))) {
			return;
		}
		applyJalaliDateControls(scope);
		translateVisibleText(scope);
		localizeDateTextNodes(scope);
		localizePlainNumbers(scope);
		localizeNumericElements(scope);
		localizePlaceholders(scope);
		localizeAttributes(scope);
		preferSetupDefaults(scope);
		applyLoginBranding(scope);
		exposeProductWorkspace(scope);
		enhanceJalaliPickerAccessibility(scope);
	}

	function initializePersianShell() {
		if (!isPersianContext() || !document.body) {
			return;
		}
		var localization = getBootLocalization();
		document.documentElement.lang = "fa";
		document.documentElement.dir = localization.direction || "rtl";
		if (document.cookie.indexOf("user_lang=fa") === -1) {
			document.cookie = "user_lang=fa; Path=/; SameSite=Lax";
		}
		if (window.frappe && window.frappe.boot) {
			window.frappe.boot.lang = "fa";
		}
		document.body.classList.add("rqerp-persian");
		applyProfileTextMap();
		patchFrappeDateConversion();
		initializeJalaliDatePicker();
		applyProductBranding();

		var brand = document.querySelector(".navbar-brand");
		if (brand && localization.persian_product_name && !brand.dataset.rqerpLocalized) {
			brand.dataset.rqerpLocalized = "1";
			brand.setAttribute("title", localization.persian_product_name);
			queryAllWithin(brand, ".nxerp-brand-mark, .rqerp-brand-mark").forEach(function (mark) {
				setTextContentIfChanged(mark, localization.persian_product_name);
			});
		}

		processPersianRoot(document.body);
	}

	var pendingRoots = new Set();
	var localizationFrame = 0;
	var localizationObserver = null;

	function flushPersianRoots() {
		localizationFrame = 0;
		var roots = Array.from(pendingRoots);
		pendingRoots.clear();
		roots.forEach(processPersianRoot);
	}

	function schedulePersianRoot(root) {
		if (!root) {
			return;
		}
		pendingRoots.add(root.nodeType === Node.TEXT_NODE ? root.parentElement : root);
		if (!localizationFrame) {
			localizationFrame = window.requestAnimationFrame(flushPersianRoots);
		}
	}

	function startPersianObserver() {
		if (!document.body || localizationObserver) {
			return;
		}
		localizationObserver = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (mutation.type === "characterData") {
					schedulePersianRoot(mutation.target);
					return;
				}
				if (mutation.type === "attributes") {
					schedulePersianRoot(mutation.target);
					return;
				}
				Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
					if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
						schedulePersianRoot(node);
					}
				});
			});
		});
		localizationObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ["aria-label", "data-original-title", "placeholder", "title"],
			characterData: true,
			childList: true,
			subtree: true,
		});
	}

	function bootPersianShell() {
		initializePersianShell();
		startPersianObserver();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", bootPersianShell);
	} else {
		bootPersianShell();
	}

	document.addEventListener("page-change", function () {
		schedulePersianRoot(document.body);
	});

	window.rqerpPersianLocalization = {
		toJalali: toJalali,
		fromJalali: fromJalali,
		formatDate: formatDate,
		formatJalaliUserValue: formatJalaliUserValue,
		formatGregorianUserValue: formatGregorianUserValue,
		isJalaliLeap: isJalaliLeap,
		normalizeDigits: normalizeDigits,
		localizeTextFragments: localizeTextFragments,
		patchFrappeDateConversion: patchFrappeDateConversion,
	};
})();
